export default {
  latest: null,
};
